<template>
  <div class="download bg-white">
    <headerCom>
      <div class="flex-lm" slot="act">
        <div class="work-acts flex-lm white-font font-size14" v-if="tableData.length>0">
          <div slot="reference" class="flex-cm work-act-single white-font font-size14">
            <div  class="botton-content flex-cm only-click-button bg-green white-font" @click="examineShow()">
              <i class="el-icon-s-check" style="width: 14px;height: 14px;margin-right: 5px;"></i>
              <span>批量审核</span>
            </div>
          </div>
          <el-popover v-if="id!=''"
                      placement="top-start"
                      width="300"
                      trigger="hover">
            <div slot="reference" class="flex-cm work-act-single white-font font-size14">
              <div  class="botton-content flex-cm only-click-button bg-green white-font">
                <img src="https://assets.pfotoo.com/pc/img/output.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                <span>导出投票记录</span>
              </div>
            </div>
            <div style="cursor: pointer;padding: 10px 0;">
              <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                       @click="exportExecl(true)">
                <span>导出当前投票记录</span>
              </el-link>
              <div class="gray-font font-size12 flex align-center">
                指当前投稿的记录
              </div>
              <div style="margin-top: 20px;">
                <el-link class="flex-lt black-font font-size14 font-bold" style="padding-bottom:5px;font-weight: bold"
                         @click="exportExecl(false)">
                  <span>导出全部投票记录</span>
                </el-link>
                <div class="gray-font font-size12 flex align-center">
                  指这个活动的全部投票记录
                </div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </headerCom>
    <div class="down-content">
      <draftcover ref="collectcover" v-on:getdraftid="getdraftid" style="display: none;"></draftcover>
      <div style="position:relative;">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 15px 0;">
          <el-breadcrumb-item :to="{ path: '/home/reports' }">下载导出</el-breadcrumb-item>
          <el-breadcrumb-item>审核投票数据</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="notice-votes">投票结束后，投票记录保存30天</div>
      </div>

      <div style="width: 100%;padding-right:15px;box-sizing: border-box;">
        <div class="table-total flex-lr bg-light-gray black-font font-size12">
          <div class="table-total flex-lm bg-light-gray black-font font-size12">
            <div class="no">{{submission?submission.serialNumber:''}}</div>
            <div class="font-size12 gray-font" style="margin-left: 20px;">有效票：</div>
            <div class="gainVotes">{{submission?submission.gainVotes:0}}票</div>
            <div class="flex-lm" style="margin-right: 35px;">
              <div class="font-size12 gray-font" style="margin-right: 10px;">时间选择</div>
              <template>
                <el-select v-model="modeltime" placeholder="请选择" @change="selecttime($event)" style="width: 150px;">
                  <el-option
                          size="mini"
                          v-for="item in timeoption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
                </el-select>
                <div class="block" :style="{marginLeft: 10+'px',display:modeltime==100 ? 'flex' : 'none'}">
                  <el-date-picker
                          @change="selectdate"
                          format="yyyy-MM-dd HH:mm"
                          v-model="value1"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </template>
            </div>
            <div class="flex-lm" style="margin-right: 35px;">
              <div class="font-size12 gray-font" style="margin-right: 10px;">投票状态</div>
              <el-dropdown size="mini" split-button  @command="dropdownEvent($event,'validStatus')">
                {{['无效','有效'][this.validStatus]||'全部'}}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="">全部</el-dropdown-item>
                  <el-dropdown-item command="1">有效</el-dropdown-item>
                  <el-dropdown-item command="0">无效</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="flex-lm" style="margin-right: 35px;">
              <div class="font-size12 gray-font" style="margin-right: 10px;">反刷票参考</div>
              <el-dropdown size="mini" split-button  @command="dropdownEvent($event,'isSuspectedCheating')">
                {{['正常投票','疑似刷票'][this.isSuspectedCheating]||'全部'}}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="">全部</el-dropdown-item>
                  <el-dropdown-item command="1">疑似刷票</el-dropdown-item>
                  <el-dropdown-item command="0">正常投票</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div style="width: 200px;text-align: right;"><a href="https://help.pfotoo.com/?p=1165" target="_blank">如何判断投票数据异常？</a></div>
        </div>
        <el-table border v-if="submission"
                :data="tableData" ref="multipleTable"
                  highlight-current-row
                  @select-all="handleTableSelect"
                  @select="handleTableSelect"
                  header-row-class-name="header-row-class-name"
                style="width: 100%"
                :height="tableHeight">
          <el-table-column fixed
                  type="selection" align="center"
                  width="55">
          </el-table-column>
          <el-table-column fixed width="55"
                  prop="downloadTime"
                  label="头像">
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="small"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
                  prop="userName"
                  label="用户昵称">
          </el-table-column>
          <el-table-column
                  align="center"
                  label="IP地址"
                  width="130">
            <template slot-scope="scope">
              <ipAddr :ip="scope.row.ipAddress" :idx="scope.$index"></ipAddr>
            </template>
          </el-table-column>
          <el-table-column align="center"
                  prop="gainVotes" width="51"
                  label="票数">
          </el-table-column>
          <el-table-column width="151" align="center"
                  prop="voteTime"
                  label="投票时间">
            <template slot-scope="scope">
              {{unixtoTime(scope.row.voteTime,'YYYY-MM-DD HH:II:SS')}}
            </template>
          </el-table-column>
          <el-table-column width="80" align="center"
                           prop="voteTime"
                           label="地区">
            <template slot-scope="scope">
              {{scope.row.position?JSON.parse(scope.row.position).city:''}}
            </template>
          </el-table-column>
          <el-table-column  width="120" align="center"
                  label="手机号">
            <template slot-scope="scope">
              {{scope.row.mobile}}
            </template>
          </el-table-column>
          <el-table-column
                  prop="reviewComments"
                  label="审核意见">
          </el-table-column>
          <el-table-column  width="151" align="center"
                  label="审核时间">
            <template slot-scope="scope">
              {{scope.row.reviewTime?unixtoTime(scope.row.reviewTime,'YYYY-MM-DD HH:II:SS'):''}}
            </template>
          </el-table-column>
          <el-table-column  width="80" align="center"
                  label="状态">
            <template slot-scope="scope">
              {{['无效','有效'][scope.row.voteStatus]}}
            </template>
          </el-table-column>
          <el-table-column width="130" align="center"
                           label="反刷票参考">
            <template slot-scope="scope">
              <pre class="text-black text-sm margin-0 text-500">{{scope.row.userRiskRank>=4?'高危投票\n已自动拦截':(scope.row.userRiskRank>=2?('疑似人工刷票\n' + '需组织者审核'):'')}}</pre>
            </template>
          </el-table-column>
          <el-table-column width="80" align="center"
                  label="审核人">
            <template slot-scope="scope">
              {{scope.row.reviewerName||''}}
            </template>
          </el-table-column>
          <el-table-column
                  fixed="right"  align="center"
                  label="操作"
                  width="60">
            <template slot-scope="scope">
              <el-button type="text" @click="examineShow(scope.row)"><i class="el-icon-s-check"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="members-page">
        <el-pagination background 
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageIndex"
                       :page-sizes="[30,50,100,150,200]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
      <examine ref="examine" v-if="submission"
               @event="examineEvent"
               :selected="selected" :submission="submission"></examine>
    </div>
  </div>
</template>

<script>
  import headerCom from '../header.vue'
  import draftcover from '../draftcover.vue'
  import App from '../../util/comfun'
  import examine from '../dialog/examine.vue'
  import ipAddr from '../card/ipaddr.vue'
  const limitRows=1000
  export default {
    name: 'download',
    data () {
      return {
        minwidth:window.innerWidth-285,
        minHeight:window.innerHeight-82,
        tableHeight:window.innerHeight-215,
        tableData: [],
        id:'',
        submission:null,

        pageIndex:1,
        pageSize:30,
        total:0,
        timeoption:[
          {
              label:'全部时间',
              value:1
          },
          {
              label:'最近7天',
              value:7
          },
          {
              label:'最近30天',
              value:30
          },
          {
              label:'自定义',
              value:100
          }
        ],
        modeltime:1,
        value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],

        selected:[],

        isSuspectedCheating:'',
        validStatus:'',
      }
    },
    components:{
      headerCom,
      draftcover,
      examine,
      ipAddr,
    },
    methods:{
      unixtoTime:App.unixtoTime,
      selecttime(val){
        console.log('selecttime',val);
        if(val==100){
          this.getvalue();
        }
        this.modeltime=val;
          this.page=1;
          this.total=0
        this.getnewlist();
      },
      selectdate(val){
        console.log(val)
        this.value1=val;
        this.page=1;
        this.total=0
        this.getnewlist();
      },

      changedate(timestamp){
              var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
              var Y= date.getFullYear();
              var M =date.getMonth()+1;
              var D =date.getDate();
              var h = date.getHours();
              var m = date.getMinutes();
              var s = date.getSeconds();
              var w=date.getDay();
              return {year:Y,month:M,day:D,hour:h,minute:m,second:s,week:w};
      },
      async getvalue(){
        let sdate=new Date(Date.parse(new Date())-30*24*60*60*1000);
        this.value1=[sdate,new Date()];
      },
      getdetail(){
        this.getnewlist()
        this.getSubmissionDetail()
      },
      getSubmissionDetail(){
        App.demand('/submission/getSubmissionDetail/{submissionId}','GET',{submissionId:this.$route.query.submissionId}).then(res=>{
          this.submission=res.data
        })
      },
      handleTableSelect(selected){
        console.log('handleTableSelect',selected)
        this.selected=selected
      },
      async getdraftid(obj){
        this.id=obj.id;
        this.getdetail();
      },
      getnewlist(){
        let paramdata={}
        if(this.modeltime!=1){
          let stime,etime;
          if(this.modeltime!=100){
            etime=Math.floor(Date.parse(new Date)/1000);
            stime=etime-this.modeltime*24*60*60;
          }else{
            stime=Math.floor(Date.parse(this.value1[0])/1000);
            etime=Math.floor(Date.parse(this.value1[1])/1000);
          }
          paramdata.cdate=stime+'-'+etime;
        }
        console.log('App.Submission.List',paramdata)
        let params = {
          "activityId": this.id,
          "pageIndex": this.pageIndex,
          "pageSize": this.pageSize,
          submissionId:this.$route.query.submissionId
        }
        if(paramdata.cdate){
          let cdate=paramdata.cdate.split('-')
          params.startTime=App.unixtoTime(cdate[0],"YYYY-MM-DD HH:II:SS")
          params.endTime=App.unixtoTime(cdate[1],"YYYY-MM-DD HH:II:SS")
        }
        if(this.isSuspectedCheating>=0){
          params.isSuspectedCheating=this.isSuspectedCheating
        }
        if(this.validStatus>=0){
          params.validStatus=this.validStatus
        }
        this.params=params
        this.tableData=[]
        //this.total=0
        App.demand('popularVote/loadPopularVoteRecord','POST',params).then(json=>{
          if(json.code==200) {
            this.tableData = json.data.recordList||[];
            this.total=json.data.total;
          }else{
            this.total=0;
            this.$message({
              showClose: true,
              message: json.message
            });

          }
        })
      },
      examineShow(one){
        if(!one){
          if(this.selected.length<1){
            return this.$message('请选中投票记录')
          }
        }
        this.$refs.examine.show(one)
      },
      examineEvent(res){
        console.log('examineEvent',res)
        if(res.act=='examine'){
          this.getdetail()
        }
      },
      handleSizeChange(pageSize){
        this.pageSize=pageSize
        this.getnewlist()
      },
      handleCurrentChange(pi){
        console.log('handleCurrentChange',pi)
        this.pageIndex=pi
        this.getnewlist()
      },
      dropdownEvent(val,key){
        console.log('dropdownEvent',...arguments)
        this[key]=val
        this.pageIndex=1
        this.getnewlist()
      },
      async exportExecl(hasOnlyCur=false){//导出execl
        let pageCount=1//Math.ceil(this.total/limitRows)
        this.downOverNum=1
        const loading = this.$loading({
          lock: true,
          text: '数据准备中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let params={
          activityId:this.submission.activityId,
        }
        if(hasOnlyCur){
          params.submissionId=this.submission.id
        }
        let fn=("votes-"+params.activityId+"-"+(params.submissionId||''))
        App.demand('/popularVote/exportVoteExcel','GET',params).then(data=>{
          loading.close();
          //let blob = new Blob([data], {type: "application/vnd.ms-excel"});
          let blob = new Blob([data], {type: "application/vnd.ms-excel"})
          //let blob = new Blob([data]);
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fn+'.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      },
    },
    mounted(){
      this.getvalue();
    },

  }
</script>

<style>
  .down-content{
    widdiv: 100%;
    position: relative;
    padding:0;
  }
  .table-header{
    background: #FAFAFA;
  }
  .tr{
    height: 40px;
    line-height: 1.4;
    overflow: hidden;
  }
  .td{
    width: 60px;
    min-height: 40px;
    text-align: center;
    padding:10px 5px;
    box-sizing: border-box;
    border-right: 1px solid #E0E0E0;
  }
  .bg-light-gray{
    background: #EEF2F2;
  }
  .table-total{
    width:100%;
    height: 50px;
    padding:0 10px;
    box-sizing: border-box;
  }
  .draft-total-data>div{
    margin-left: 20px;
    color: #999;
  }
  .draft-total-data>div:first-child{
    margin-left: 10px;
  }
  .draft-total-data .font-size14{
    color: #353535;
  }
  .down-content{
    width: 100%;
    padding-left:15px;
    box-sizing: border-box;
  }
  /* .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  } */
  .table{
    width: 100%;
    border-top: 1px solid #E0E0E0;
    box-sizing: border-box;
    min-height: 540px;
    border-collapse: collapse;
  }
  .td:first-child{
    border-left: 1px solid #E0E0E0;
  }
  .checkbox {
    width: 16px;
    height: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
  }
  .page{
    padding: 40px 0;
  }
  .work-img{
    width:20px;
    height:20px;
    display: inline-block;
  }
  .td a{

  }
  .td a:hover{
    color: #27C4A2;
  }
  .pdf-mask{
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index:9999;
    background: rgba(0,0,0,.8);
  }
  .pdf-cover{
    width: 800px;
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    margin: 0 auto;
    z-index:10000;
    overflow: scroll;
    box-sizing: border-box;
  }
  .detail-unit-list {
      padding-top: 18px;
  }
  .detail-unit-single {
      margin-right: 30px;
      margin-bottom: 10px;
      line-height: 20px;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 500;
  }
  .unit-green-font {
      border-bottom: 1px solid #3dc4a7;
  }
  .el-icon-arrow-up:before {
      content: "\E6E1";
      position: relative;
      top: -6px;
  }
  .down-content .el-input__inner{
      height: 30px!important;
      line-height: 30px!important;
  }
  .el-date-editor--datetimerange.el-input__inner {
      width: 356px;
  }
  .el-date-editor .el-icon-time{
    line-height: 22px;
  }
  .el-date-editor .el-range-separator{
    line-height: 22px;
  }
  .search{
    height: 36px;
    border-radius: 5px;
    background: #F2F2F3;
    margin-right: 20px;
  }
  .search-input{
      width: 100px;
      height: 100%;
      outline: none;
      transition: width ease .3s;
      background: transparent;
      padding: 0 5px;
      border: 0;
      box-sizing: border-box;
      line-height: 36px;
      font-size: 14px;
      margin-right: 5px;
  }
    .search-button{
    padding: 0 10px;
    height: 100%;
  }
  .search-button img{
    width: 15px;
    height: 16px;
  }
  .header-row-class-name .cell{
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Light;
    font-weight: 300;
    color: #999999;
    line-height: 17px;
  }
  .no{
    min-width: 70px;
    height: 20px;
    background: linear-gradient(180deg,#fde6c6, #eecb9d);
    border-radius: 200px 100px 100px 0px;
    box-shadow: 0px 0px 2px 0px rgba(208,207,207,0.50);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #5d5d5d;
    position: relative;
    text-indent: 42px;
    width: 100px;
  }
  .no::before{
    background-image: url("https://assets.pfotoo.com/vote/vote%20%283%29.png");
    background-position: 10px center;
    background-repeat: no-repeat;
    background-size: 22px 10px;
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left: 0;
    content: "";
  }
  .gainVotes{
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #353535;
    margin-right: 50px;
  }
  .notice-votes{
    width: 329px;
    height: 40px;
    background-size: 100% 100%;
    background-image: url("https://assets.pfotoo.com/images/pc-help/%E7%BC%96%E7%BB%84%203@3x.png");
    position: absolute;
    left:calc(50% - 160px);
    top:2px;

    color: #5d5d5d;
    font-size: 14px;
    font-face: PingFangSC;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0;
    paragraph-spacing: 0;
    text-align: left;
    text-indent: 58px;
  }
</style>


// WEBPACK FOOTER //
// src/components/list/votes.vue